import React from 'react';

import { useHeaderContext } from '../../../context';
import { CompanyLink } from '../company-link';
import { CompanyLogo } from '../company-logo';
import { CompanyName } from './company-name';

import * as S from './subheader.styles';

export const Subheader: React.FC = () => {
  const { industry } = useHeaderContext();

  return (
    <S.Subheader data-testid="header-company-info">
      <CompanyLogo />
      <S.CompanyInfo>
        <CompanyLink>
          <CompanyName />
        </CompanyLink>
        <S.Industry>{industry}</S.Industry>
      </S.CompanyInfo>
    </S.Subheader>
  );
};
